import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';

const TextInput = ({
  input, label, meta: { error, touched, warning }, rows, multiLine, rowsMax, hintText, customStyle, ...custom
}) =>
  (<TextField
    {...input}
    {...custom}
    hintText={hintText}
    style={{ ...customStyle }}
    floatingLabelText={label}
    errorText={touched && (error || warning)}
    fullWidth
    multiLine={multiLine}
    rows={rows}
    rowsMax={rowsMax}
  />);

TextInput.propTypes = {
  rows: 1,
  rowsMax: 1,
  multiLine: false,
  hintText: '',
  label: '',
};

TextInput.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  label: PropTypes.node,
  customStyle: PropTypes.object,
  rows: PropTypes.number,
  rowsMax: PropTypes.number,
  multiLine: PropTypes.bool,
  hintText: PropTypes.node,
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/form/TextInput.js